/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchedulerCrewResponse } from '../../models/scheduler-crew-response';

export interface GetSchedulerCrew$Params {
  id: number;
}

export function getSchedulerCrew(http: HttpClient, rootUrl: string, params: GetSchedulerCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulerCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, getSchedulerCrew.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchedulerCrewResponse>;
    })
  );
}

getSchedulerCrew.PATH = '/api/scheduler/crew/{id}';
